import core from 'Shared/assets/locales/fr/core.json'
import partials from 'Shared/assets/locales/fr/partials.json'

import constants from './constants.json'
import menuItems from './menuItems.json'
import pages from './pages.json'

export const localeFr = {
	core,
	partials,
	constants,
	menuItems,
	pages
}
